import { render, staticRenderFns } from "./ActionsWatch.vue?vue&type=template&id=3ca84a62&scoped=true&"
import script from "./ActionsWatch.vue?vue&type=script&lang=js&"
export * from "./ActionsWatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca84a62",
  null
  
)

export default component.exports